import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, forkJoin, of } from 'rxjs';
import { exhaustMap, first, map, switchMap, tap } from 'rxjs/operators';
import { AppConfig } from 'src/app/app-config.loader';
import { DocumentiService } from 'src/app/core/documenti.service';
import { Etichetta } from 'src/app/shared/models/etichetta.model';

@Component({
  selector: 'app-stampa-etichetta',
  standalone: true,
  imports: [CommonModule],
  template: `
  <div class="container">
    @if (etichetta$ | async; as etichetta) {
    <div class="title">{{titleLabel}}</div>
    <div class="label">Prot n.:</div>
    <div>{{etichetta.doc.protocollo}} del {{etichetta.doc.dataProtocollazione | date:'dd/MM/yyyy' }}</div>
    <div class="label">Fascicolo:</div>
    <div>{{etichetta.pos}}</div>
    @if (etichetta.doc.carico) {
    <div class="label">Carico:</div>
    <div>{{etichetta.doc.carico}}</div>
    }
    <div class="nota">{{etichetta.doc.noteEtichetta}}&nbsp;  
      @if (appConfig.logic.fascicoloEtichettaCustom.includes(siglaFascicolo)) {
        {{appConfig.text.stampa_etichetta.etichettaCustom}}
    }</div>
  }
  </div>
  `,
  styles: [`
    .container {
      display: grid;
      align-items: center;
      padding: 0 5px 0 20px;
      grid-template-columns: 75px auto;
      grid-template-rows: 2rem 2rem 2rem;
      gap: 0px 0px;
      width: 340px; /* px = (cm * 24.5) / dpi */
      height: 135px;
      background-color: #FFF;
      font-size: 12px;
      border: 1px solid #000;
    }
    .title { grid-column-start: span 2; text-align: center; }
    .nota { grid-column-start: span 2; text-align: left; padding-left: 5px;}
    .label { font-weight: bold; font-size: 14px;}
  `]
})
export class StampaEtichettaComponent implements OnInit {
  public titleLabel: string;
  public etichetta$: Observable<{ doc: Etichetta, pos: string }> | null = null;
  public siglaFascicolo = '';
  public appConfig: AppConfig;

  constructor(private _appConfig: AppConfig, private documentiService: DocumentiService, private route: ActivatedRoute) {
    this.appConfig = _appConfig;
    this.titleLabel = this.appConfig.text.stampa_etichetta.ente;
  }

  ngOnInit(): void {
    this.etichetta$ = this.route.paramMap.pipe(
      switchMap((params) => of(params.get('id'))),
      first(),
      exhaustMap(id => forkJoin({
        doc: this.documentiService.getEtichetta(+id!),
        pos: this.documentiService.getPosizione(+id!)
          .pipe(
            map(posizioneResponse => {
              const pos = posizioneResponse[this.appConfig.logic.hierarchy.descriptionIndex];
              let fascicolo = this.siglaFascicolo = `${pos.sigla}`;
              for (let i = this.appConfig.logic.hierarchy.descriptionIndex + 1; i < posizioneResponse.length; i++) {
                if (posizioneResponse[i]) {
                  fascicolo += ` - ${posizioneResponse[i].sigla}`;
                }
              }

              return fascicolo;
            })
          )
      })),
      tap(() => setTimeout(window.print, 500))
    );
  }
}
